import { AxiosError } from 'axios';

export type FeedbackType = 'success' | 'error' | 'info';

export interface NotifyPayload {
  title: string;
  description?: string;
  type?: FeedbackType;
  addToActivity?: boolean;
}

type NotifyHandler = (payload: NotifyPayload) => void;

let notifyHandler: NotifyHandler | null = null;

export const registerFeedbackHandler = (handler: NotifyHandler | null) => {
  notifyHandler = handler;
};

export const notifyFeedback = (payload: NotifyPayload) => {
  notifyHandler?.(payload);
};

export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const responseData = error.response?.data as { message?: string; error?: string } | undefined;
    const apiMessage = responseData?.message || responseData?.error;

    if (apiMessage && apiMessage.trim() !== '') {
      return apiMessage;
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'Terjadi kesalahan yang tidak diketahui';
};

export const notifySuccess = (title: string, description?: string, addToActivity = true) => {
  notifyFeedback({ title, description, type: 'success', addToActivity });
};

export const notifyInfo = (title: string, description?: string, addToActivity = true) => {
  notifyFeedback({ title, description, type: 'info', addToActivity });
};

export const notifyError = (title: string, error: unknown, addToActivity = true) => {
  notifyFeedback({
    title,
    description: extractErrorMessage(error),
    type: 'error',
    addToActivity,
  });
};
